export enum FinancialAccountTransactionCategory {
  ASSET_LIQUIDATION = 'asset_liquidation',
  DEBT_REPAYMENT = 'debt_repayment',
  CASH_DISTRIBUTION = 'cash_distribution',
  REVENUE = 'revenue',
  EXPENSE = 'expense'
}
